import { Fragment, useEffect, useRef, useState } from 'react'
import { motion, useInView, useScroll, useTransform } from 'framer-motion'

import { useMedia } from 'hooks/useMedia'
import { breakpoints } from 'styles/mq'
import GoldenBg from 'assets/golden-bg.webp'
import { ClickablePoint, Img, Scroll, Svg } from './styled'

const clickablePointsCoords = [
  { x: 73, y: 63 },
  { x: 242, y: 154 },
  { x: 33, y: 180 },
  { x: 110, y: 154 },
  { x: 94, y: 213 },
  { x: 43, y: 376 },
  { x: 70, y: 520 },
  { x: 84, y: 500 },
]

const slideImages = [...Array(7)].map((_, index) => ({
  ...clickablePointsCoords[index],
  image: require(`./assets/costume_${index + 1}.webp`),
  textSvg: require(`./assets/costume_${index + 1}.svg`),
}))

export const CostumeAnimation = () => {
  const [visibleIndexClickable, setVisibleIndexClickable] = useState(0)
  const ref = useRef(null)
  const [visibleIndexScrollable, setVisibleIndexScrollable] = useState(0)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start start', 'end end'],
  })
  const slideNum = useTransform(scrollYProgress, input =>
    Math.round(input * (slideImages.length - 1))
  )
  const isLarge = useMedia([breakpoints.large], [true], false)

  const imageRef = useRef<SVGSVGElement>(null)
  useInView(ref)
  const transformY = useTransform(
    scrollYProgress,
    [0, 1],
    isLarge ? [100, -100] : [0, 0]
  )
  const circleTransform = useTransform(transformY, [100, -100], [50, -50])

  useEffect(() => {
    slideNum.on('change', () => setVisibleIndexScrollable(slideNum.get()))
  }, [])

  const visibleIndex = isLarge ? visibleIndexScrollable : visibleIndexClickable

  return (
    <Scroll ref={ref}>
      <Svg
        ref={imageRef}
        style={{ y: transformY }}
        viewBox="0 0 390 573"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <pattern
            id="costume-pattern"
            width="1"
            height="1"
            patternContentUnits="objectBoundingBox"
          >
            <image x="0" y="0" width="3" height="2" xlinkHref={GoldenBg} />
          </pattern>
        </defs>

        <motion.circle
          cx="194.5"
          cy="278.5"
          r="225.5"
          fill="#C5DDDA"
          fillOpacity="0.8"
          style={{ y: circleTransform }}
        />

        {slideImages.map(({ image, textSvg }, index) => (
          <Fragment key={index}>
            <Img
              isVisible={visibleIndex === index}
              x="-159"
              width="667"
              height="573"
              xlinkHref={image}
            />
            <Img
              isVisible={visibleIndex === index}
              x="-40"
              y="-1"
              width="450"
              height="573"
              xlinkHref={textSvg}
            />
          </Fragment>
        ))}

        {slideImages.map(({ x, y }, index) => (
          <g
            key={index}
            onClick={() => setVisibleIndexClickable(index)}
            style={{ cursor: 'pointer' }}
          >
            <circle cx={x + 6} cy={y + 6} r="20" fill="rgba(0,0,0,0.01)" />
            <motion.g
              animate={
                visibleIndex === index ? { scale: 1.6, rotateZ: '90deg' } : {}
              }
            >
              <ClickablePoint
                d="M11 5.5L8.939 6.196C7.6474 6.633 6.6336 7.647 6.1969 8.938L5.5003 10.999L4.8036 8.938C4.367 7.647 3.3532 6.633 2.0616 6.196L0 5.5L2.061 4.80299C3.3526 4.36599 4.3664 3.353 4.8031 2.061L5.4997 0L6.1964 2.061C6.633 3.353 7.6468 4.36599 8.9384 4.80299L11 5.5Z"
                transform={`translate(${x} ${y})`}
                fill={
                  visibleIndex === index ? 'url(#costume-pattern)' : '#343431'
                }
              />
            </motion.g>
          </g>
        ))}
      </Svg>
    </Scroll>
  )
}
